import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { services } from '../mockData';

const Services = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
              I Nostri Servizi
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Soluzioni Complete per la Vostra Sicurezza
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Offriamo un'ampia gamma di prodotti e servizi per proteggere la vostra casa o attività commerciale
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div 
              key={service.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-slate-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2 text-gray-700">
                      <div className="bg-green-100 rounded-full p-1">
                        <Check size={14} className="text-green-600" />
                      </div>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <button 
                  onClick={() => scrollToSection('quote')}
                  className="w-full bg-slate-900 text-white py-3 rounded-lg hover:bg-green-600 transition-colors flex items-center justify-center gap-2 group font-medium"
                >
                  Richiedi Preventivo
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-slate-50 to-green-50 rounded-2xl p-8 md:p-12 border border-green-100">
            <h3 className="text-3xl font-bold text-slate-900 mb-4">
              Non hai trovato quello che cerchi?
            </h3>
            <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
              Offriamo soluzioni personalizzate per ogni esigenza. Contattaci per un consulto gratuito.
            </p>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-green-600 text-white px-8 py-4 rounded-lg hover:bg-green-700 transition-all hover:shadow-lg font-semibold inline-flex items-center gap-2"
            >
              Contattaci Ora
              <ArrowRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
